export default __webpack_public_path__ + "static/media/team31.6df4a097.JPG";